import actions from '../actions/signed';
import base from '../../../reducers/base';

const reducer = base(actions.types);
export default reducer;
